import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
    '@global': {
        ul: {
          margin: 0,
          padding: 0,
          listStyle: 'none',
          color: '#fff !important'
        },
          color: '#fff !important',
          textSecondary: 'white'
    
      },
      
      link: {
        margin: theme.spacing(1, 1.5),
      },
    
     
      footer: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        [theme.breakpoints.up('lg')]: {
          paddingTop: theme.spacing(6),
          paddingBottom: theme.spacing(6),
        },
        textAlign: 'left'
      },
     
      white : {
        color : 'white'
      },
      headlineButton: {
        textAlign: 'left',
        backgroundColor: '#7c71d5',
        [theme.breakpoints.up('xs')]: {
          borderRadius: '20px',
          paddingLeft: '20px',
          paddingRight: '20px',
          paddingTop: '1px',
          paddingBottom: '1px',
          fontSize:'10px'
        },      
        [theme.breakpoints.up('sm')]: {
          borderRadius: '20px',
          paddingLeft: '20px',
          paddingRight: '20px',
          paddingTop: '1px',
          paddingBottom: '1px'
        },
        [theme.breakpoints.up('md')]: {        
          borderRadius: '30px',
          paddingLeft: '30px',
          paddingRight: '30px',
          paddingTop: '5px',
          paddingBottom: '3px'
        },
        [theme.breakpoints.up('lg')]: {
          borderRadius: '30px',
          paddingLeft: '25px',
          paddingRight: '25px',
          paddingTop: '3px',
          paddingBottom: '1px'
        },
        },
        buttonText:{
            color: '#fbfbfb',
            fontFamily: 'Baloo Tamma 2',
            fontWeight: 400,
            fontSize: '15px',
            textTransform: 'capitalize'
        },
        dividerLine: {
          paddingTop: '30px',
          borderBottom: '1px solid #7c71d5'
        }
}));
